export class TipoDocumentoReferencia {
   codigo: string;
   nombre: string;
}
